/**
 * Entry point for pinia.
 * All configurations/initializations related to pinia must reside in this file
 */

import { createPinia } from 'pinia'
import { resetStorePlugin, storagePlugin } from './plugins'

const pinia = createPinia()

pinia.use(resetStorePlugin)
pinia.use(storagePlugin)
export default pinia
